import { ButtonProps } from '@/components/Button/Button.types.ts';
import { Carousel } from '@/components/Carousel/Carousel.types';
import type { Channel } from '@/pages/Channel/Channel.types';
import { FileForm } from '@/pages/File/File.types';
import { NewTicket } from '@/pages/Ticket/Ticket.types';
import type { User } from '@/pages/User/User.types';
import type { EventBusKey } from '@vueuse/core';

export const submitChannelButtonClickKey: EventBusKey<null> = Symbol('on-submit-channel-button-click-key');

export const updateChannelUsersButtonClickKey: EventBusKey<null> = Symbol('on-update-channel-users-button-click-key');

export const submitChannelFormKey: EventBusKey<Channel> = Symbol('on-submit-channel-form-key');

export const setAuthLayoutCarouselItemsKey: EventBusKey<Carousel[]> = Symbol('on-set-auth-layout-carousel-items-key');

export const updateChannelFooterKey: EventBusKey<{
  isOpen: boolean;
  actions: ButtonProps[];
}> = Symbol('on-update-channel-footer-key');

export const serviceStatsButtonClickKey: EventBusKey<null> = Symbol('on-service-stats-button-click-key');

export const recordStatsButtonClickKey: EventBusKey<null> = Symbol('on-record-stats-button-click-key');

export const sessionRefetchButtonClickKey: EventBusKey<null> = Symbol('on-session-refetch-button-click-key');

export const submitUserButtonClickKey: EventBusKey<null> = Symbol('on-submit-user-button-click-key');

export const submitUserFormKey: EventBusKey<User> = Symbol('on-submit-user-form-key');

export const updateUserChannelsButtonClickKey: EventBusKey<null> = Symbol('on-update-user-channels-button-click-key');

export const updateUserFooterKey: EventBusKey<{
  isOpen: boolean;
  actions: ButtonProps[];
}> = Symbol('on-update-user-footer-key');

export const updateFileFooterKey: EventBusKey<{
  isOpen: boolean;
  actions: ButtonProps[];
}> = Symbol('on-update-file-footer-key');

export const submitFileButtonClickKey: EventBusKey<null> = Symbol('on-submit-file-button-click-key');

export const submitFileFormKey: EventBusKey<FileForm> = Symbol('on-submit-file-form-key');

export const updateRecordsFooterKey: EventBusKey<{
  isOpen: boolean;
  actions: ButtonProps[];
}> = Symbol('on-update-record-files-footer-key');

export const submitRecordFormKey: EventBusKey<{
  title: string;
}> = Symbol('on-submit-record-form-key');

export const submitRecordButtonClickKey: EventBusKey<null> = Symbol('on-submit-record-button-click-key');

export const clearFileChannelsSelectionKey: EventBusKey<null> = Symbol('on-clear-file-channels-selection-key');

export const submitNewTicketButtonClickKey: EventBusKey<null> = Symbol('submit-new-ticket-button-click-key');

export const submitNewTicketFormKey: EventBusKey<{
  form: NewTicket;
  files: File[] | [];
}> = Symbol('submit-new-ticket-form-key');

export const submitReplyButtonClickKey: EventBusKey<null> = Symbol('submit-reply-button-click-key');

export const submitReplayTicketFormKey: EventBusKey<{
  msg: string;
  files: File[] | [];
}> = Symbol('submit-replay-ticket-form-key');

export const clearReplyTicketInputKey: EventBusKey<null> = Symbol('clear-reply-ticket-input-key');
